__turbopack_context__.v({
  "subtitle": "_1S4uZq_subtitle",
  "title": "_1S4uZq_title",
});
